import { createContext, useContext, useState } from 'react';
import { InlineBannerProps } from '@cad-arc';

const EventPanelBannersReadContext = createContext<InlineBannerProps[]>([]);

const EventPanelBannersWriteContext = createContext<
    undefined | ((banners: InlineBannerProps[]) => void)
>(undefined);

export function EventPanelBannersProvider(props: { children: React.ReactNode }) {
    const [eventPanelBanners, setEventPanelBanners] = useState<InlineBannerProps[]>([]);
    return (
        <EventPanelBannersReadContext.Provider value={eventPanelBanners}>
            <EventPanelBannersWriteContext.Provider value={setEventPanelBanners}>
                {props.children}
            </EventPanelBannersWriteContext.Provider>
        </EventPanelBannersReadContext.Provider>
    );
}

export function useSetEventPanelBanners() {
    const value = useContext(EventPanelBannersWriteContext);
    if (!value) throw new Error('Unexpectedly did not find value on EventPanelBannersWriteContext');
    return value;
}

export function useEventPanelBanners() {
    return useContext(EventPanelBannersReadContext);
}
